import VerifyPhoneStepOne from './VerifyPhoneStepOne'

export default VerifyPhoneStepOne
